import { render, staticRenderFns } from "./IconSelect.vue?vue&type=template&id=9aafbaa8&scoped=true&"
import script from "./IconSelect.vue?vue&type=script&lang=js&"
export * from "./IconSelect.vue?vue&type=script&lang=js&"
import style0 from "./IconSelect.vue?vue&type=style&index=0&id=9aafbaa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aafbaa8",
  null
  
)

export default component.exports